import { all } from 'redux-saga/effects';
import accreditationsListSettingsSaga from '../containers/admin/accreditations/accreditationsList/saga';
import accreditationsSaga from '../containers/clients/components/accreditations/accreditationList/saga';
import accreditationsSettingsLogsSaga from '../containers/admin/accreditations/accreditation/logs/saga';
import accreditationsSettingsSaga from '../containers/admin/accreditations/accreditation/saga';
import activeJobsSaga from '../containers/jobs/activeJobList/saga';
import addAccreditationSaga from '../containers/clients/components/accreditations/accreditation/addAccreditation/saga';
import adminAlgorithmSaga from '../containers/admin/algorithm/saga';
import adminEditUnmatchedOptionSaga from '../containers/admin/editUnmatchedOption/saga';
import adminReferralsSaga from '../containers/admin/referrals/saga';
import adminUnmatchOptionsSaga from '../containers/admin/unmatchOptions/saga';
import agenciesActiveList from '../containers/agencies/activeList/saga';
import agenciesInviteList from '../containers/agencies/inviteList/saga';
import agenciesRemovedList from '../containers/agencies/removedList/saga';
import agencyContractsV2Editor from '../containers/agencies/agencyContractsV2/editAgencyContract/saga';
import agencyContractsV2Mutations from '../containers/agencies/agencyContractsV2/mutations/saga';
import agencyContractsV2Pickers from '../containers/agencies/agencyContractsV2/pickers/saga';
import agencyContractsV2RateLines from '../containers/agencies/agencyContractsV2/viewAgencyContract/rateLines/saga';
import agencyContractsV2View from '../containers/agencies/agencyContractsV2/viewAgencyContract/saga';
import agencyCreateEdit from '../containers/agencies/editAgency/saga';
import agencyView from '../containers/agencies/viewAgency/saga';
import agencyViewComments from '../containers/agencies/viewAgency/comments/saga';
import agencyViewLogs from '../containers/agencies/viewAgency/logs/saga';
import agencyViewUsers from '../containers/agencies/viewAgency/users/saga';
import updateAgencyContract from '../containers/agencies/updateAgencyContract/saga';
import appSaga from './app/saga';
import applicantAccreditationSaga from '../containers/applicants/applicant/accreditations/accreditation/saga';
import applicantAccreditationsSaga from '../containers/applicants/applicant/accreditations/accreditationsList/saga';
import applicantAssessmentsSaga from '../containers/applicants/applicant/assessments/saga';
import applicantCommentsSaga from '../containers/applicants/applicant/comments/saga';
import applicantExperiencesSaga from '../containers/applicants/applicant/experiences/experiencesList/saga';
import applicantInterviewDetailsSaga from '../containers/applicants/applicant/interviewDetails/saga';
import applicantLogsSaga from '../containers/applicants/applicant/logs/saga';
import applicantReferralsSaga from '../containers/applicants/applicant/referrals/referralsList/saga';
import applicantSaga from '../containers/applicants/applicant/saga';
import applicantSessoinsSaga from '../containers/applicants/applicant/sessions/saga';
import applicantSuperannuationsSaga from '../containers/applicants/applicant/superannuations/saga';
import applicantsSaga from '../containers/applicants/applicantList/saga';
import assignMultidayWorkerSaga from '../containers/jobs/job/bookings/booking/assignMultidayWorker/saga';
import assignTalentSaga from '../containers/jobs/job/bookings/booking/assign/saga';
import attentionRequiredListSaga from '../containers/jobs/attentionRequiredList/saga';
import TimeSheetsListSaga from '../containers/jobs/timesheetsList/saga';
import attireSaga from '../containers/admin/attires/attire/saga';
import attiresSaga from '../containers/admin/attires/attireList/saga';
import authSagas from './auth/saga';
import automationConfigSaga from '../containers/admin/automationConfig/saga';
import orgCancellationPolicySaga from '../containers/admin/cancellationPolicy/saga';
import orgCancellationPolicyLogsSaga from '../containers/admin/cancellationPolicy/logs/saga';
import unitAgenciesSaga from '../containers/clients/units/unit/agencies/saga';
import unitEditAgenciesSaga from '../containers/clients/units/unit/agencies/editAgencies/saga';
import blockedTalentsSaga from '../containers/clients/units/unit/blockedTalents/saga';
import bookingSaga from '../containers/jobs/job/bookings/booking/saga';
import bulkEditCheckinCheckoutSaga from '../containers/jobs/job/bookings/booking/bulkEditCheckinCheckout/saga';
import calendarViewSaga from '../containers/jobs/calendarView/saga';
import changeToWorkingSaga from '../containers/jobs/job/bookings/booking/changeToWorking/saga';
import agencyCancellationPolicy from '../containers/agencies/viewAgency/cancellationPolicy/saga';
import checklistsSaga from '../containers/admin/checklists/saga';
import clientCommentsSaga from '../containers/clients/units/unit/comments/saga';
import clientFeedbackOptionsSaga from '../containers/admin/clientFeedbackOptions/saga';
import clientLogsSaga from '../containers/clients/units/unit/logs/saga';
import clientSaga from '../containers/clients/units/unit/saga';
import clientsSaga from '../containers/clients/units/unitList/saga';
import companiesSaga from '../containers/clients/companies/companyList/saga';
import companyCommentsSaga from '../containers/clients/companies/company/comments/saga';
import companyDivisionsGridSaga from '../containers/clients/companies/company/divisionsGrid/saga';
import companyLogsSaga from '../containers/clients/companies/company/logs/saga';
import companySaga from '../containers/clients/companies/company/saga';
import companyUnitsGridSaga from '../containers/clients/companies/company/unitsGrid/saga';
import contractSpecificAgreementsSaga from '../containers/clients/companies/company/contractSpecificAgreements/saga';
import dataTableSaga from '../components/dataTable/saga';
import dataUploadsSaga from '../containers/settings/dataUploads/saga';
import demoUserSaga from '../containers/admin/demoUsers/demoUser/saga';
import demoUsersSaga from '../containers/admin/demoUsers/demoUsersList/saga';
import deniedTalentsSaga from '../containers/admin/deniedTalent/deniedTalentList/saga';
import districtLogsSaga from '../containers/admin/districts/district/viewDistrict/districtLogs/saga';
import districtSaga from '../containers/admin/districts/district/saga';
import districtsSaga from '../containers/admin/districts/districtList/saga';
import divisionCommentsSaga from '../containers/clients/divisions/division/comments/saga';
import divisionLogsSaga from '../containers/clients/divisions/division/logs/saga';
import divisionSaga from '../containers/clients/divisions/division/saga';
import divisionUnitsGridSaga from '../containers/clients/divisions/division/unitsGrid/saga';
import divisionsSaga from '../containers/clients/divisions/divisionList/saga';
import editAccreditationSaga from '../containers/clients/components/accreditations/accreditation/editAccreditation/saga';
import editBackupsSaga from '../containers/jobs/job/bookings/booking/editBackups/saga';
import editBookingSaga from '../containers/jobs/job/bookings/booking/editBooking/saga';
import editProfileSaga from '../containers/profile/saga';
import editShiftSaga from '../containers/jobs/job/bookings/booking/editShift/saga';
import flexAppOptionsSaga from '../containers/admin/flexAppOptions/saga';
import futureJobsSaga from '../containers/jobs/futureJobList/saga';
import holidayPricingLogsSaga from '../containers/admin/holidayPricing/logs/saga';
import holidayPricingSaga from '../containers/admin/holidayPricing/saga';
import infractionReportModal from '../containers/talent/talent/pastJobsList/jobsList/infractionReportModal/saga';
import PendingSkillModalSaga from '../containers/talent/talent/skills/pendingSkillsModal/saga';
import SkillsSaga from '../containers/talent/talent/skills/saga';
import infractionsExceptions from '../containers/landingPage/infractionsExceptions/saga';
import newSkillApplications from '../containers/landingPage/newSkillsApplications/saga';
import interviewPopup from '../containers/applicants/interviewPopup/saga';
import interviewsSaga from '../containers/applicants/interviewList/saga';
import jobAddPromocodeSaga from '../containers/jobs/job/addPromocode/saga';
import jobAtRiskSaga from '../containers/landingPage/jobsAtRisk/saga';
import jobAttentionRequiredListSaga from '../containers/jobs/job/attentionRequired/saga';
import jobCommentsSaga from '../containers/jobs/job/comments/saga';
import jobLogsSaga from '../containers/jobs/job/logs/saga';
import jobManagersSaga from '../containers/jobs/job/managers/saga';
import jobOtherPayoutsSaga from '../containers/jobs/job/otherPayouts/saga';
import jobSaga from '../containers/jobs/job/saga';
import jobTypesListSaga from '../containers/admin/positions/jobTypes/saga';
import jobTypesMutationsSaga from '../containers/admin/positions/jobTypes/mutations/saga';
import landingPage from '../containers/landingPage/saga';
import leaderBoardListSaga from '../containers/landingPage/leaderBoard/saga';
import leadsSaga from '../containers/leads/leadList/saga';
import legalEntitiesListSaga from '../containers/admin/legalEntities/legalEntitiesList/saga';
import createLegalEntitySaga from '../containers/admin/legalEntities/createLegalEntity/saga';
import legalEntitiesOptionsSaga from './legalEntitiesOptions/saga';
import managerSaga from '../containers/clients/units/unit/managers/manager/saga';
import managersSaga from '../containers/clients/units/unit/managers/managerList/saga';
import marketDistrictsListSaga from '../containers/admin/markets/market/disctrictsList/saga';
import marketSaga from '../containers/admin/markets/market/saga';
import marketsListSaga from '../containers/admin/markets/marketsList/saga';
import messagesSaga from '../containers/jobs/job/messages/saga';
import notificationsCenterSaga from '../containers/notificationsCenter/saga';
import notificationsSaga from './notifications/saga';
import onBehalfOfSaga from '../containers/onBehalfOf/saga';
import orgSwitcherSaga from './orgSwitcher/saga';
import organizationSaga from '../containers/organizations/organization/saga';
import organizationsListSaga from '../containers/organizations/organizationsList/saga';
import pantsDetailSaga from '../containers/admin/attires/attire/attireGroups/pants/saga';
import pantsSaga from '../containers/admin/attires/attire/attireGroups/pantsList/saga';
import partnerSaga from '../containers/admin/partners/partner/saga';
import partnersSaga from '../containers/admin/partners/partnerList/saga';
import pastJobsSaga from '../containers/jobs/pastJobList/saga';
import paymentHistorySaga from '../containers/jobs/job/paymentHistory/saga';
import payrollSaga from '../containers/admin/payroll/saga';
import poolSaga from '../containers/jobs/job/bookings/booking/pools/saga';
import poolAgenciesSaga from '../containers/jobs/job/bookings/booking/pools/tabs/agencies/saga';
import poolsBreakdownListSaga from '../containers/landingPage/poolsBreakdown/saga';
import positionAccreditationsSaga from '../containers/admin/positions/position/accreditations/accreditationsList/saga';
import positionLogsSaga from '../containers/admin/positions/position/logs/logList/saga';
import positionSaga from '../containers/admin/positions/position/saga';
import positionsSaga from '../containers/admin/positions/positionList/saga';
import predictionsListSaga from '../containers/landingPage/predictions/saga';
import positionAvailabilitySaga from '../containers/admin/pricing/positionAvailability/saga';
import editRateEngineSaga from '../containers/admin/pricing/rateEngine/editRateEngine/saga';
import rateEngineFormDataSaga from '../containers/admin/pricing/rateEngine/rateEngineShared/formData/saga';
import rateEngineListSaga from '../containers/admin/pricing/rateEngine/rateEngineList/saga';
import rateEngineListShortSaga from '../containers/admin/pricing/rateEngine/rateEngineShared/listShort/saga';
import rateEngineMutationsSaga from '../containers/admin/pricing/rateEngine/rateEngineShared/mutations/saga';
import viewRateEngineSaga from '../containers/admin/pricing/rateEngine/viewRateEngine/saga';
import rateCardsSaga from '../containers/admin/pricing/rateCards/saga';
import rateCardCreateSaga from '../containers/admin/pricing/rateCards/createRateCard/saga';
import rateCardReviewSaga from '../containers/admin/pricing/rateCards/reviewRateCard/saga';
import rateCardViewSaga from '../containers/admin/pricing/rateCards/viewRateCard/saga';
import rateSimulatorSaga from '../containers/admin/pricing/rateSimulator/saga';
import promoCodeSaga from '../containers/admin/promoCodes/promoCode/saga';
import promoCodesSaga from '../containers/admin/promoCodes/promoCodeList/saga';
import removeMultidayWorkerSaga from '../containers/jobs/job/bookings/booking/removeMultidayWorker/saga';
import resolveHoursSaga from '../containers/jobs/job/bookings/booking/resolveHours/saga';
import reviewTimingsSaga from '../containers/jobs/job/bookings/booking/reviewTimingsModal/saga';
import sectorLogsSaga from '../containers/admin/sectors/sector/logList/saga';
import sectorSaga from '../containers/admin/sectors/sector/saga';
import sectorsSaga from '../containers/admin/sectors/sectorList/saga';
import sessionAddSaga from '../containers/orientations/addSession/saga';
import sessionCalendarSaga from '../containers/orientations/sessions/session/sections/sessionCalendar/saga';
import sessionCommentsSaga from '../containers/orientations/sessions/session/sections/sessionComments/commentList/saga';
import sessionListActiveSaga from '../containers/orientations/sessions/sessionListActive/saga';
import sessionListFutureSaga from '../containers/orientations/sessions/sessionListFuture/saga';
import sessionListPastSaga from '../containers/orientations/sessions/sessionListPast/saga';
import sessionLogsSaga from '../containers/orientations/sessions/session/sections/sessionLogs/saga';
import sessionManagersSaga from '../containers/orientations/sessions/session/sections/sessionManagers/saga';
import sessionRecruitsSaga from '../containers/orientations/sessions/session/sections/sessionRecruits/saga';
import sessionSaga from '../containers/orientations/sessions/session/saga';
import sessionTeamChatSaga from '../containers/orientations/sessions/session/sections/sessionTeamChat/saga';
import settingsSaga from '../containers/settings/saga';
import shirtSaga from '../containers/admin/attires/attire/attireGroups/shirt/saga';
import shirtsSaga from '../containers/admin/attires/attire/attireGroups/shirtList/saga';
import shoesDetailSaga from '../containers/admin/attires/attire/attireGroups/shoes/saga';
import shoesSaga from '../containers/admin/attires/attire/attireGroups/shoesList/saga';
import subUnitBlockedTalentsSaga from '../containers/clients/subUnits/subUnit/blockedTalents/saga';
import subUnitCommentsSaga from '../containers/clients/subUnits/subUnit/comments/saga';
import subUnitInvoiceJobSaga from '../containers/clients/subUnits/subUnit/invoices/invoice/invoiceJobsList/saga';
import subUnitInvoiceNonActivatedJobSaga from '../containers/clients/subUnits/subUnit/invoices/invoice/invoiceNonActivatedJobsList/saga';
import subUnitInvoiceSaga from '../containers/clients/subUnits/subUnit/invoices/invoice/saga';
import subUnitInvoicesSaga from '../containers/clients/subUnits/subUnit/invoices/invoiceList/saga';
import subUnitLogsSaga from '../containers/clients/subUnits/subUnit/logs/saga';
import subUnitManagerSaga from '../containers/clients/subUnits/subUnit/managers/manager/saga';
import subUnitManagersSaga from '../containers/clients/subUnits/subUnit/managers/managerList/saga';
import subUnitPriceListSaga from '../containers/clients/subUnits/subUnit/priceList/saga';
import subUnitReferralsSaga from '../containers/clients/subUnits/subUnit/referrals/saga';
import subUnitSaga from '../containers/clients/subUnits/subUnit/saga';
import subUnitsMyTeamListSaga from '../containers/clients/subUnits/subUnit/myTeam/saga';
import subUnitsSaga from '../containers/clients/subUnits/subUnitList/saga';
import talentAccreditationSaga from '../containers/talent/talent/accreditations/accreditation/saga';
import talentAccreditationsSaga from '../containers/talent/talent/accreditations/accreditationsList/saga';
import talentBackgroundChecks from '../containers/talent/talent/backgroundChecks/saga';
import talentBlockedUnitsSaga from '../containers/talent/talent/blockedUnits/saga';
import talentCareerSaga from '../containers/talent/talent/career/saga';
import talentCommentsSaga from '../containers/talent/talent/comments/saga';
import talentConversionRuleSaga from '../containers/clients/companies/company/talentConversionRule/saga';
import talentJobInvitesSaga from '../containers/talent/talent/jobInvites/saga';
import talentLogsSaga from '../containers/talent/talent/logs/saga';
import talentPastJobsCalendarViewSaga from '../containers/talent/talent/pastJobsList/calendarView/saga';
import talentPastJobsListSaga from '../containers/talent/talent/pastJobsList/jobsList/saga';
import talentReferralsSaga from '../containers/talent/talent/referrals/referralsList/saga';
import talentSaga from '../containers/talent/talent/saga';
import talentSuperannuationsSaga from '../containers/talent/talent/superannuations/saga';
import talentSuspensionSaga from '../containers/talent/talent/suspension/saga';
import talentWarningAndSuspensionsSaga from '../containers/talent/talent/warningAndSuspensions/saga';
import talentsSaga from '../containers/talent/talentList/saga';
import terminatedTalentsSaga from '../containers/admin/terminatedTalent/terminatedTalentList/saga';
import termsPrivacySaga from '../containers/admin/terms&privacy/saga';
import transferAssociateSaga from '../containers/applicants/applicant/transferAssociate/saga';
import trustedTalentApplicantSaga from '../containers/applicants/applicant/trustedTalentApplicantModal/saga';
import unclosedJobs from '../containers/landingPage/unclosedJobs/saga';
import undoNCNSFormSaga from '../containers/jobs/job/bookings/booking/undoNCNSForm/saga';
import unitInvoiceJobSaga from '../containers/clients/units/unit/invoices/invoice/invoiceJobsList/saga';
import unitInvoiceNonActivatedJobSaga from '../containers/clients/units/unit/invoices/invoice/invoiceNonActivatedJobsList/saga';
import unitInvoiceSaga from '../containers/clients/units/unit/invoices/invoice/saga';
import unitInvoicesSaga from '../containers/clients/units/unit/invoices/invoiceList/saga';
import unitPriceListSaga from '../containers/clients/units/unit/priceList/saga';
import addNewPriceListSaga from '../containers/clients/units/unit/priceList/addNewPriceList/saga';
import addNewPriceListImportFileSaga from '../containers/clients/units/unit/priceList/addNewPriceList/importFileModal/saga';
import unitReferralsSaga from '../containers/clients/units/unit/referrals/saga';
import unitSubUnitsSaga from '../containers/clients/units/unit/subUnitsGrid/saga';
import unitsMyTeamListSaga from '../containers/clients/units/unit/myTeam/saga';
import AddApplicantToMyTeamSaga from '../containers/clients/units/unit/myTeam/addApplicantModal/saga';
import UnitPaymentMethodsCardsSaga from '../containers/clients/units/unit/paymentMethods/tabs/cards/saga';
import UnitPaymentMethodsBankAccountsSaga from '../containers/clients/units/unit/paymentMethods/tabs/bankAccounts/saga';
import UnitPaymentMethodsInvoicesSaga from '../containers/clients/units/unit/paymentMethods/tabs/invoices/saga';
import UnitPaymentMethodsCreditsSaga from '../containers/clients/units/unit/paymentMethods/tabs/credits/saga';
import UnitEditPaymentMethodsSaga from '../containers/clients/units/unit/paymentMethods/details/saga';
import UnitEditPaymentMethodsSagaAddCreditCardSaga from '../containers/clients/units/unit/paymentMethods/details/detailsComponents/creditCards/modal/saga';
import UnitEditPaymentMethodsSagaAddBankAccountSaga from '../containers/clients/units/unit/paymentMethods/details/detailsComponents/bankAccounts/modal/saga';
import UnitEditPaymentMethodsSagaCreditsCardSaga from '../containers/clients/units/unit/paymentMethods/details/detailsComponents/creditCards/saga';
import PaymentMethodsAddCreditModal from '../containers/clients/units/unit/paymentMethods/tabs/credits/modal/saga';
import unmatchedTrends from '../containers/landingPage/unmatchedTrends/saga';
import updateRatingsSaga from '../containers/jobs/job/bookings/booking/updateRatings/saga';
import userGuide from '../containers/userGuide/saga';
import userLogsSaga from '../containers/admin/users/user/logList/saga';
import userSaga from '../containers/admin/users/user/saga';
import usersSaga from '../containers/admin/users/userList/saga';
import yourApplicants from '../containers/landingPage/yourApplicants/saga';
import invoiceListSaga from '../containers/agencies/invoiceList/saga';
import orgniazationSaga from '../containers/admin/organization/saga';
import loginWithSSOSaga from '../containers/loginWithSSO/saga';
import globalSearchSaga from '../containers/globalSearch/saga';
import AddNewSkillModalSaga from '../containers/talent/talent/skills/addSkillModal/saga';
import EnableSkillModalSaga from '../containers/talent/talent/skills/enableSkillModal/saga';
import ViewSkillModal from '../containers/talent/talent/skills/viewSkillModal/saga';
import BulkUploadWorkers from '../containers/talent/talentList/bulkUploadWorkers/saga';
import appUserBootstrapSaga from './appUserBootstrap/saga';
import appBootstrapSaga from './appBootstrap/saga';
import viewAgencyWorkerSaga from '../containers/agencyWorkers/viewAgencyWorker/saga';
import agencyWorkersSaga from '../containers/agencyWorkers/agencyWorkersList/saga';
import convertToPermanentSaga from '../containers/agencyWorkers/convertToPermanent/saga';

export default function* rootSaga(_getState) {
  const sagas = [
    // Main
    appSaga(),
    authSagas(),
    appUserBootstrapSaga(),
    appBootstrapSaga(),
    // Containers
    accreditationsListSettingsSaga(),
    accreditationsSaga(),
    accreditationsSettingsLogsSaga(),
    accreditationsSettingsSaga(),
    activeJobsSaga(),
    addAccreditationSaga(),
    adminAlgorithmSaga(),
    adminEditUnmatchedOptionSaga(),
    adminReferralsSaga(),
    adminUnmatchOptionsSaga(),
    agenciesActiveList(),
    agenciesInviteList(),
    agenciesRemovedList(),
    agencyCreateEdit(),
    agencyView(),
    agencyContractsV2View(),
    agencyContractsV2RateLines(),
    agencyContractsV2Editor(),
    agencyContractsV2Pickers(),
    agencyContractsV2Mutations(),
    agencyViewComments(),
    agencyViewLogs(),
    agencyViewUsers(),
    updateAgencyContract(),
    applicantAccreditationSaga(),
    applicantAccreditationsSaga(),
    applicantAssessmentsSaga(),
    applicantCommentsSaga(),
    applicantExperiencesSaga(),
    applicantInterviewDetailsSaga(),
    applicantLogsSaga(),
    applicantReferralsSaga(),
    applicantSaga(),
    applicantSessoinsSaga(),
    applicantSuperannuationsSaga(),
    applicantsSaga(),
    assignMultidayWorkerSaga(),
    assignTalentSaga(),
    attentionRequiredListSaga(),
    TimeSheetsListSaga(),
    attireSaga(),
    attiresSaga(),
    automationConfigSaga(),
    orgCancellationPolicySaga(),
    orgCancellationPolicyLogsSaga(),
    unitAgenciesSaga(),
    unitEditAgenciesSaga(),
    blockedTalentsSaga(),
    bookingSaga(),
    bulkEditCheckinCheckoutSaga(),
    calendarViewSaga(),
    changeToWorkingSaga(),
    agencyCancellationPolicy(),
    checklistsSaga(),
    clientCommentsSaga(),
    clientFeedbackOptionsSaga(),
    clientLogsSaga(),
    clientSaga(),
    clientsSaga(),
    companiesSaga(),
    companyCommentsSaga(),
    companyDivisionsGridSaga(),
    companyLogsSaga(),
    companySaga(),
    companyUnitsGridSaga(),
    contractSpecificAgreementsSaga(),
    dataTableSaga(),
    dataUploadsSaga(),
    demoUserSaga(),
    demoUsersSaga(),
    deniedTalentsSaga(),
    districtLogsSaga(),
    districtSaga(),
    districtsSaga(),
    divisionCommentsSaga(),
    divisionLogsSaga(),
    divisionSaga(),
    divisionUnitsGridSaga(),
    divisionsSaga(),
    editAccreditationSaga(),
    editBackupsSaga(),
    editBookingSaga(),
    editProfileSaga(),
    editShiftSaga(),
    flexAppOptionsSaga(),
    futureJobsSaga(),
    holidayPricingLogsSaga(),
    holidayPricingSaga(),
    infractionReportModal(),
    PendingSkillModalSaga(),
    SkillsSaga(),
    infractionsExceptions(),
    newSkillApplications(),
    interviewPopup(),
    interviewsSaga(),
    jobAddPromocodeSaga(),
    jobAtRiskSaga(),
    jobAttentionRequiredListSaga(),
    jobCommentsSaga(),
    jobLogsSaga(),
    jobManagersSaga(),
    jobOtherPayoutsSaga(),
    jobSaga(),
    jobTypesListSaga(),
    jobTypesMutationsSaga(),
    landingPage(),
    leaderBoardListSaga(),
    leadsSaga(),
    legalEntitiesListSaga(),
    createLegalEntitySaga(),
    legalEntitiesOptionsSaga(),
    managerSaga(),
    managersSaga(),
    marketDistrictsListSaga(),
    marketSaga(),
    marketsListSaga(),
    messagesSaga(),
    notificationsCenterSaga(),
    notificationsSaga(),
    onBehalfOfSaga(),
    orgSwitcherSaga(),
    organizationSaga(),
    organizationsListSaga(),
    pantsDetailSaga(),
    pantsSaga(),
    partnerSaga(),
    partnersSaga(),
    pastJobsSaga(),
    paymentHistorySaga(),
    payrollSaga(),
    poolSaga(),
    poolAgenciesSaga(),
    poolsBreakdownListSaga(),
    positionAccreditationsSaga(),
    positionLogsSaga(),
    positionSaga(),
    positionsSaga(),
    predictionsListSaga(),
    positionAvailabilitySaga(),
    editRateEngineSaga(),
    rateEngineFormDataSaga(),
    rateEngineListSaga(),
    rateEngineListShortSaga(),
    rateEngineMutationsSaga(),
    viewRateEngineSaga(),
    rateCardsSaga(),
    rateCardCreateSaga(),
    rateCardReviewSaga(),
    rateCardViewSaga(),
    rateSimulatorSaga(),
    promoCodeSaga(),
    promoCodesSaga(),
    removeMultidayWorkerSaga(),
    resolveHoursSaga(),
    reviewTimingsSaga(),
    sectorLogsSaga(),
    sectorSaga(),
    sectorsSaga(),
    sessionAddSaga(),
    sessionCalendarSaga(),
    sessionCommentsSaga(),
    sessionListActiveSaga(),
    sessionListFutureSaga(),
    sessionListPastSaga(),
    sessionLogsSaga(),
    sessionManagersSaga(),
    sessionRecruitsSaga(),
    sessionSaga(),
    sessionTeamChatSaga(),
    settingsSaga(),
    shirtSaga(),
    shirtsSaga(),
    shoesDetailSaga(),
    shoesSaga(),
    subUnitBlockedTalentsSaga(),
    subUnitCommentsSaga(),
    subUnitInvoiceJobSaga(),
    subUnitInvoiceNonActivatedJobSaga(),
    subUnitInvoiceSaga(),
    subUnitInvoicesSaga(),
    subUnitLogsSaga(),
    subUnitManagerSaga(),
    subUnitManagersSaga(),
    subUnitPriceListSaga(),
    addNewPriceListImportFileSaga(),
    subUnitReferralsSaga(),
    subUnitSaga(),
    subUnitsMyTeamListSaga(),
    AddApplicantToMyTeamSaga(),
    UnitPaymentMethodsCardsSaga(),
    UnitPaymentMethodsBankAccountsSaga(),
    UnitPaymentMethodsInvoicesSaga(),
    UnitPaymentMethodsCreditsSaga(),
    UnitEditPaymentMethodsSaga(),
    UnitEditPaymentMethodsSagaAddCreditCardSaga(),
    UnitEditPaymentMethodsSagaAddBankAccountSaga(),
    UnitEditPaymentMethodsSagaCreditsCardSaga(),
    PaymentMethodsAddCreditModal(),
    subUnitsSaga(),
    talentAccreditationSaga(),
    talentAccreditationsSaga(),
    talentBackgroundChecks(),
    talentBlockedUnitsSaga(),
    talentCareerSaga(),
    talentCommentsSaga(),
    talentConversionRuleSaga(),
    talentJobInvitesSaga(),
    talentLogsSaga(),
    talentPastJobsCalendarViewSaga(),
    talentPastJobsListSaga(),
    talentReferralsSaga(),
    talentSaga(),
    talentSuperannuationsSaga(),
    talentSuspensionSaga(),
    talentWarningAndSuspensionsSaga(),
    talentsSaga(),
    terminatedTalentsSaga(),
    termsPrivacySaga(),
    transferAssociateSaga(),
    trustedTalentApplicantSaga(),
    unclosedJobs(),
    undoNCNSFormSaga(),
    unitInvoiceJobSaga(),
    unitInvoiceNonActivatedJobSaga(),
    unitInvoiceSaga(),
    unitInvoicesSaga(),
    unitPriceListSaga(),
    addNewPriceListSaga(),
    unitReferralsSaga(),
    unitSubUnitsSaga(),
    unitsMyTeamListSaga(),
    unmatchedTrends(),
    updateRatingsSaga(),
    userGuide(),
    userLogsSaga(),
    userSaga(),
    usersSaga(),
    yourApplicants(),
    invoiceListSaga(),
    orgniazationSaga(),
    loginWithSSOSaga(),
    globalSearchSaga(),
    AddNewSkillModalSaga(),
    EnableSkillModalSaga(),
    ViewSkillModal(),
    BulkUploadWorkers(),
    viewAgencyWorkerSaga(),
    agencyWorkersSaga(),
    convertToPermanentSaga(),
  ];

  yield all(sagas);
}
